import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { notificationService } from "service/NotificationService";
import { apiService } from "service/ApiService";
import StoreContext from "contexts/StoreContext";
import SaveButton from "components/Buttons/SaveButton";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";

import { useTranslation } from "react-i18next";

export default function ExtraCategoriesSelectModal({ categoryId, show, handleClose }) {
  const {
    t,
  } = useTranslation();

  const [extraCategories, setExtraCategories] = useState([]);
  const [selectedExtraCategories, setSelectedExtracategories] = useState([]);
  const { storeId, setStoreId } = useContext(StoreContext);
  const [errorMessage, setErrorMessage] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const fetchData = async () => {
    try {
      const dataResponse = await apiService.get(`api/v1/extra-categories/store/${storeId}`);
      setExtraCategories(dataResponse.filter((o) => !o.deleted));
    } catch (error) {
      console.error("Error fetching data:", error);
      notificationService.notifyError(error.message);
    }
  };

  const fetchSelected = async () => {
    try {
      const dataResponse = await apiService.get(`api/v1/extra-category-assignments/category/${categoryId}`);
      setSelectedExtracategories(dataResponse.map((item) => item.extraCategory.id));
    } catch (error) {
      console.error("Error fetching data:", error);
      notificationService.notifyError(error.message);
    }
  };

  const handleSelect = (item) => {
    if (selectedExtraCategories.includes(item.id)) setSelectedExtracategories(selectedExtraCategories.filter((i) => i !== item.id));
    else setSelectedExtracategories([...selectedExtraCategories, item.id]);
  };

  const save = () => {
    setIsDisabled(true);
    apiService
      .postJson(`api/v1/extra-category-assignments/category/${categoryId}`, selectedExtraCategories)
      .then((resp) => {
        notificationService.notifySuccess(t("messages.extraCategoriesUpdatedSuccessfully"));
        setIsDisabled(false);
        handleClose();
      })
      .catch((error) => {
        setErrorMessage(error.message);
        notificationService.notifyError(error.message);
        setIsDisabled(false);
        handleClose();
      });
  };

  useEffect(() => {
    if (!categoryId) return;
    fetchData();
    fetchSelected();
  }, [categoryId]);

  return (
    <>
      <Modal size="xl" dialogClassName="my-modal" show={show} onHide={handleClose} aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("common.labels.extraCategories")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form action="/" className="form-horizontal" method="get">
            <fieldset>
              <Form.Group>
                <Row>
                  {extraCategories.map((item, index) => (
                    <Form.Check key={index}>
                      <Form.Check.Label>
                        <Form.Check.Input type="checkbox" checked={selectedExtraCategories.includes(item.id)} onChange={() => handleSelect(item)} />
                        <span className="form-check-sign"></span>
                        <h5>{item.name}</h5>
                      </Form.Check.Label>
                    </Form.Check>
                  ))}
                </Row>
              </Form.Group>
            </fieldset>
          </Form>
          <Row className="float-left">
            <Col>
              <SaveButton handler={save} disabled={isDisabled} />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}
